import { combineReducers } from 'redux'

import list from './list/slice'

const receivedReducer = combineReducers({
  list,
})

export default receivedReducer
